var _circle, _circle2, _path, _path2, _circle3, _circle4, _path3, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1838,
    cy: 38.4189,
    r: 27,
    transform: "rotate(-45 38.1838 38.4189)",
    fill: "#FAFBFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1837,
    cy: 38.4189,
    r: 20,
    transform: "rotate(-45 38.1837 38.4189)",
    fill: "#F2F4FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2979 35.2837C28.5907 38.1123 27.9306 40.1866 29.3448 43.7222C30.2732 46.0434 27.074 46.6231 24.7488 43.3684C22.9808 40.8938 23.1026 35.8223 25.0553 33.8695C27.008 31.9168 30.0051 32.4552 29.2979 35.2837Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8403 52.5611C51.6508 44.7506 51.6508 32.0873 43.8403 24.2768C41.0207 21.4572 37.5687 19.6555 33.9408 18.8716C40.3624 17.4842 47.3347 19.2859 52.3256 24.2768C60.1361 32.0873 60.1361 44.7506 52.3256 52.5611C47.3347 57.552 40.3624 59.3537 33.9408 57.9662C37.5687 57.1824 41.0207 55.3807 43.8403 52.5611Z",
    fill: "#ECEEF9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1837,
    cy: 38.4189,
    r: 20,
    transform: "rotate(-45 38.1837 38.4189)",
    stroke: "#222638",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1838,
    cy: 38.4189,
    r: 27,
    transform: "rotate(-45 38.1838 38.4189)",
    stroke: "#222638",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5685 61.046L59.3969 63.8745M59.3969 55.3892L63.6396 59.6318",
    stroke: "#222638",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56.5684,
    y: 65.2891,
    width: 12,
    height: 32,
    rx: 6,
    transform: "rotate(-45 56.5684 65.2891)",
    fill: "#3455FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5684,
    y: 65.2891,
    width: 12,
    height: 32,
    rx: 6,
    transform: "rotate(-45 56.5684 65.2891)",
    stroke: "#222638",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens);
export default __webpack_public_path__ + "static/media/lens.0b4c13c0ec75c12c0970b91a1222976c.svg";
export { ForwardRef as ReactComponent };